import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const RoutesView = Backbone.View.extend({
  el: '#club-routes',
  initialize: function() {
    this.editable = this.options.editable;
    this.tags = this.options.tags;
    this.data = this.options.data.map(this.cleanRouteData)
    this.clubId = this.options.clubId;
    this.eventCount = this.options.eventCount;
    this.experienceCount = this.options.experienceCount;
    this.collectionCount = this.options.collectionCount;
    this.userPinnedRoutes = this.options.userPinnedRoutes || []
    rwgps.hasRouteLink = this.options.hasRouteLink || {}
    this.userDateFormat = this.options.userDateFormat;
    this.isClubAdmin = this.options.isClubAdmin
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    var params = rwgps.Utils.getQueryParameters(window.location.search)
    var viewingArchives = params.archive === 'true'
    this.$el.toggleClass('showingArchives', viewingArchives)
    this.$el.toggleClass('showingLibrary', !viewingArchives)

    this.initSliders()
    this.initTagInputBoxes();
    this.initGrid();

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // filtering
    'click .toggle_filters': 'toggleFilters',
    'keyup .filter_by_name': 'filterTextInputChanged',
    'keyup .filter_by_location': 'filterTextInputChanged',
    'change .filter_by_tag': 'filtersChanged',
    // bulk operations
    'click .bulk-op-disabled': 'showDisabledMessage',
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_set_locality': 'batchSetLocality',
    'click .backup': 'batchBackup',
    'click .batch_delete': 'batchDelete',
    'click .batch_set_visibility': 'batchSetVisibility',
    'click .plan_ride': 'newEvent',
    'click .batch_event_add': 'addToEvent',
    'click .event_add_link': 'loadEvents',
    'click .create_experience': 'createExperience',
    'click .experience_add_link': 'loadExperiences',
    'click .batch_experience_add': 'addToExperience',
    'click .collection_add_link': 'loadCollections',
    'click .batch_collection_add': 'addToCollection',
    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
    'click .batch_lock': 'batchLock',
    'click .batch_archive': 'batchArchive',
    'click .batch_unarchive': 'batchUnarchive',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight',
    'mousedown .route-info': 'routeInfo',
    'mousedown .route-link': 'routeLink',
    'mouseover .slick-cell': 'linkMousedOver'
  },
  initGrid: function() {
    const data = this.data,
      formatters = FilteringGridWithBulkOperations.formatters;

    // use custom column names for Cascade Bicycle Club
    let tagColumnName = T.t('tags');
    let locationColumnName = T.t('location');
    if (this.clubId == 4) {
      tagColumnName = "Starting Point";
      locationColumnName = "Starting City/Sector";
    }

    // column definitions
    const columns = [
      {id:"name", name:T.t('route_name'), field:"name", sortable:true, formatter: formatters.routeName.bind(this), editor:Slick.Editors.Text},
      {id:"tags", name:tagColumnName, field:"tags", sortable:true, formatter: formatters.tags},
      {id:"location_str", name:locationColumnName, field:"location_str", sortable:true},
      {id:"distance", name:T.t('distance_short') + ' (' + (rwgps.LabelMaker.metric ? 'km':'mi') + ')', field:"distance", sortable:true, formatter: formatters.distance},
      {id:"elevation_gain", name:T.t('elevation_short') + ' (' + (rwgps.LabelMaker.metric ? 'm':'ft') + ')', field:"elevation_gain", sortable:true, formatter: formatters.elevationGain}
    ];
    if(this.editable) {
      columns.push(
        {id:"visibility", name:T.t('privacy'), field:"visibility", sortable:true, formatter: formatters.visibility, editor:Slick.Editors.YesNoFriendsSelect, isClub: true}
      );
    }
    columns.push(
      {id:"updated_at", name:T.t('updated'), field:"updated_at", sortable:true, formatter: formatters.date.bind(this)}
    );
    if(this.editable) {
      if (rwgps.clubs.show.featureFlags.includes('content_portal_route_links')) {
        columns.push(
          {id:"route_link", name: '', field:"route_link", formatter: formatters.routeLink, resizable: false}
        );
      }
      columns.push(
        {id:"info", name: '', field:"info", formatter: formatters.info, resizable: false}
      );
    } else {
      columns.push(
        {id:"pin", name: '', field:"pin", formatter: formatters.pin.bind(this), resizable: false}
      );
    }

    const hoverPreviewViewFormatter = (row,cell,val,col,item) => (`<a class="row-link showPreview" data-id="${item.id}" data-type="route" data-name="${item.name}" data-elevationGain="${item.elevation_gain}" data-elevationLoss="${item.elevation_loss}" data-distance="${item.distance}" data-privacyCode="${item.privacyCode}" href="/routes/${item.id}">View</a>`)

    const columnWidths = Object.assign({
      tags: 170,
      location_str: 125,
      distance: 80,
      elevation_gain: 75,
      visibility: 65,
      updated_at: 90,
      info: 50,
      route_link: 50,
      pin: 50
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    const tagFilter = this.$('.filter_by_tag')
    const locationFilter = this.$('.filter_by_location')
    const nameFilter = this.$('.filter_by_name')
    const filterAccessors = new Map(Object.entries({
      name: nameFilter.val.bind(nameFilter),
      location_str: locationFilter.val.bind(locationFilter),
      tag_names: tagFilter.select2.bind(tagFilter, "val"),
      distance: this.distSlider,
      elevation_gain: this.eleSlider
    }))

    var params = rwgps.Utils.getQueryParameters(window.location.search)
    var viewingArchives = params.archive === 'true'

    this.grid = new FilteringGridWithBulkOperations(data, {
      target: '#routes_table',
      columns: columns,
      editable: this.editable,
      updatePath: function(id) { return '/routes/'+id+'/simple_update.json';},
      updateParam: 'route',
      viewFormatter: hoverPreviewViewFormatter,
      ignoreCaseOnSort: ['name', 'location_str'],
      filterAccessors: filterAccessors,
      settingsOpts: this.settings.opts
    })

    // case insensitive sort of concatenated tags
    this.grid.sortingFn('tags', (a, b) => {
      const x = (a.tag_names || []).join().toUpperCase(), y = (b.tag_names || []).join().toUpperCase();
      return (x==y ? 0 : (x > y ? 1 : -1));
    })


    this.grid.enableFiltering([
      {field: 'name', type: 'string'},
      {field: 'location_str', type: 'string'},
      {field: 'tag_names', type: 'arraySubset'},
      {field: 'distance', type: 'range'},
      {field: 'elevation_gain', type: 'range'},
      {field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives)}
    ]);

    this.grid.enableBulkOperations({
      bulkUpdateAttributePath: '/routes/batch_set_attr.json',
      bulkDeletePath: '/routes/batch_destroy.json',
      idsParam: 'route_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    }

    const self = this
    this.grid.slickGrid.onSelectedRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    this.grid.dataView.onRowsChanged.subscribe(() => self.updateBulkOpVisibility())
  },

  /*
   * filtering
   */

  toggleFilters: function() {
    if (this.$('.toggle_filters .plus').is(':visible')) {
      this.showFilters()
    } else {
      this.hideFilters()
    }
  },

  showFilters: function() {
    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
    this.$('.filters').show();
  },

  hideFilters: function() {
    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
    this.$('.filters').hide();
  },

  filterTextInputChanged: function(e) {
    // clear on escape
    if(e.which == 27) e.currentTarget.value = '';
    this.filtersChanged()
  },

  filtersChanged: function() {
    if (this.grid) { this.grid.filterInputsChanged() }
  },


  getFilterByViewingArchives: (viewingArchives) => {
    return (item) => {
      if (viewingArchives) {
        return !!item.archived_at
      }
      if (!viewingArchives) {
        return !item.archived_at
      }
    }
  },

  makeSlider: function(opts) {
    const self = this
    const metric = rwgps.LabelMaker.metric
    const sliderValues = opts.values
    const labelElem = opts.labelElem
    const sliderElem = opts.sliderElem
    const maxIndex = 32

    var units, toMeters, fromMeters
    if (opts.longUnits) {
      units = metric ? 'distance.km' : 'distance.miles'
      toMeters = rwgps.Convert.longToM
      fromMeters = rwgps.Convert.mToLong
    } else {
      units = metric ? 'distance.meters' : 'distance.feet'
      toMeters = rwgps.Convert.shortToM
      fromMeters = rwgps.Convert.mToShort
    }

    function changed(newIndexes) {
      const lowIndex = newIndexes[0] || 0
      const highIndex = newIndexes[1] || maxIndex
      const lowValue = sliderValues[lowIndex]
      const highValue = sliderValues[highIndex]

      if(lowIndex == 0 && highIndex == maxIndex) {
        labelElem.html(T.t(opts.anyLabelKey))
      } else if(lowIndex == 0) {
        labelElem.html(T.t('less_than') +' '+ T.t(units, {count: highValue}))
      } else if(highIndex == maxIndex) {
        labelElem.html(T.t('more_than') + ' ' + T.t(units, {count: lowValue}))
      } else {
        labelElem.html(lowValue + ' - ' + T.t(units, {count: highValue}))
      }

      // Don't call filtersChanged until after the current execution stack has
      // finished. The slider element doesn't get updated with the new indexes
      // until this function returns, so if we don't wait, when filtersChanged
      // indirectly calls the accessor below it'll get the old values, not the
      // new ones
      setTimeout(() => self.filtersChanged(), 0)
    }

    sliderElem.slider({
      range: true,
      min: 0,
      max: maxIndex,
      values: [0, maxIndex],
      slide: (event, ui) => changed(ui.values)
    })

    changed([0, maxIndex])

    function accessor(values) {
      if (values === undefined) {
        // If no arg has been passed, return the current values
        var indexes = sliderElem.slider('values') || []
        if (indexes.length == 0) {
          indexes = [0, maxIndex]
        } else if (indexes.length == 1) {
          indexes = [indexes[0], maxIndex]
        }
        return (indexes).map(idx => sliderValues[idx]).map(toMeters)
      } else {
        if (values.length == 0) {
          values = [0, Infinity]
        } else if (values.length == 1)
        {
          values = [values[0], Infinity]
        }

        // Otherwise, set the values on the slider
        const maxFinite = sliderValues[sliderValues.length - 2]
        const newIndexes = values.map(fromMeters).map(val => {
          // Find the index of the closest value in sliderValues for each new value
          var closestIdx = null
          var closestDiff = null
          if (Number.isFinite(val) && val < maxFinite * 1.5) {
            sliderValues.forEach((sliderValue, idx) => {
              const diff = Math.abs(val - sliderValue)
              if (closestIdx === null || diff < closestDiff) {
                closestIdx = idx
                closestDiff = diff
              }
            })
          } else {
            closestIdx = maxIndex
          }

          return closestIdx
        })

        if (newIndexes[0] >= maxIndex) { newIndexes[0] = 31 } // Don't allow low end to be infinity

        sliderElem.slider('values', newIndexes)
        changed(newIndexes)
      }
    }

    return accessor
  },

  initSliders: function() {
    const distVals = [0,1,2,3,4,5,6,7,8,9,10,12,15,20,25,30,35,40,45,50,60,70,80,90,100,150,200,250,300,350,400,450,Infinity];
    this.distSlider = this.makeSlider({
      sliderElem: this.$(".length-slider"),
      labelElem: this.$(".length-label"),
      longUnits: true,
      values: distVals,
      anyLabelKey: 'any_length'
    })

    // quadratic easing function with values 0 => 0, 15 => 2500, 31 => 10000
    var eleVals = [...Array(32).keys()].map((_, i) => Math.round((9.745 * i * i + 20.5 * i)/100) * 100)
    eleVals.push(Infinity)
    this.eleSlider = this.makeSlider({
      sliderElem: this.$(".elevation-slider"),
      labelElem: this.$(".elevation-label"),
      longUnits: false,
      values: eleVals,
      anyLabelKey: 'any_gain'
    })
  },

  /*
   * bulk operations
   */

  updateBulkOpVisibility: function() {
    const grid = this.grid.slickGrid
    const data = grid.getData()
    const items = grid.getSelectedRows().map(i => data.getItem(i))

    const noneSelected = items.length == 0 ? T.t('no_route_selected') : null
    const anyLocked = items.some(i => i.locked) ? T.t('routes_are_locked') : null
    const noEvents = this.eventCount === 0 ? T.t('no_event_created') : null
    const noExperiences = this.experienceCount === 0 ? T.t('no_experience_created') : null
    const noCollections = this.collectionCount === 0 ? T.t('no_collection_created') : null

    const shouldDisable = {
      tags: noneSelected || anyLocked,
      locality: noneSelected || anyLocked,
      visibility: noneSelected || anyLocked,
      archive: noneSelected,
      unarchive: noneSelected,
      delete: noneSelected || anyLocked,
      backup: noneSelected,
      event_add: noneSelected || noEvents,
      experience_add: noneSelected || noExperiences,
      collection_add: noneSelected || noCollections,
      lock: items.every(i => i.locked) ? T.t('all_routes_locked') : null,
      unlock: !anyLocked ? T.t('all_routes_unlocked') : null
    }

    this.$("[data-bulk-op]").each((idx, el) => {
      const elem = $(el)
      const op = elem.data("bulk-op")
      const disableMessage = shouldDisable[op]

      if (disableMessage) {
        elem.addClass("bulk-op-disabled")
        elem.data("disabled", disableMessage)
      } else {
        elem.removeClass("bulk-op-disabled")
        elem.removeData("disabled")
        elem.removeAttr("data-disabled")
      }
    })

    this.$('.bulk_op').hide();
  },

  showDisabledMessage: function(e) {
    const message = $(e.currentTarget).data('disabled')
    $("#disabled-op-content").html(message)
    $("#disabled-op").modal("show")

    e.stopImmediatePropagation()
  },

  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    const show = !this.$('.bulk_op_' + bulkOp).is(':visible');
    this.$('.bulk_op').hide();
    if(show)
      this.$('.bulk_op_' + bulkOp).show();
    return false;
  },

  batchSetLocality: function() {
    const locality = this.$('input.new_locality').val();
    this.grid.setAttributeOnSelectedItems('locality', locality, (item) => {
      item.location_str = locality;
    });
  },

  batchBackup: function() {
    const items = this.grid.selectedItems;
    if(!items.length) return false;

    customConfirm(T.t('confirm_backup'), () => {
      const ids = _.map(items, ({id}) => id);
      $.post('/user_backups', {user_backup: {format: 'json', content: {routes: ids}}}, function(resp) {
        customAlert(resp.message);
      });
    })
    return false;
  },

  batchDelete: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert(T.t('no_route_selected'));
    } else {
      customConfirm(T.t('confirm_delete', {count: items.length}), () => this.grid.deleteSelectedItems());
    }
    return false;
  },

  batchSetVisibility: function() {
    const visVal = parseInt(this.$('select.visibility').val());
    this.grid.setAttributeOnSelectedItems('visibility', visVal);
  },

  batchArchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert(T.t('no_route_selected'));
    } else {
      customConfirm(T.t('confirm_archive', {count: items.length}), () => {
        this.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(() => {
          this.grid.setSelectedRows([]);
        })
      });
    }
    return false;
  },

  batchUnarchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert(T.t('no_route_selected'));
    } else {
      customConfirm(T.t('confirm_unarchive', {count: items.length}), () => {
        this.grid.setAttributeOnSelectedItems('archived_at', null).always(() => {
          this.grid.setSelectedRows([]);
        })
      });
    }
    return false;
  },

  newEvent: function() {
    const items = this.grid.selectedItems;
    rwgps.createEventModal({ initialRouteIds: items.map(i => i.id) })
  },

  loadEvents: function() {
    if (this.eventsLoading || this.eventsLoaded) {
      return false;
    }

    this.eventsLoading = true
    this.eventsLoaded = false

    // TODO: Loading spinner, if needed
    $.getJSON(`/organizations/${this.clubId}/table_events.json?minimal=1`)
      .done((data) => {
        const eventSelector = this.$('input.event_add')
        const addButton = this.$(".batch_event_add")

        addButton.addClass("disabled")
        data.forEach((obj) => { obj.text = obj.name })
        eventSelector.val('').select2({
          width: '300px',
          placeholder: T.t('select_event'),
          data: data,
          selectOnBlur: true,
          formatNoMatches: () => ''
        });
        eventSelector.on("change", () => {
          const val = eventSelector.select2("val")
          if (val === '') {
            addButton.addClass("disabled")
          } else {
            addButton.removeClass("disabled")
          }
        })
        this.eventsLoaded = true
      })
      .always(() => { this.eventsLoading = false })
    return false;
  },

  addToEvent: function() {
    if (this.addingToEvent) {
      return
    }

    this.addingToEvent = true
    const eventSelector = this.$('input.event_add')
    const eventData = eventSelector.select2("data");
    const itemCount = this.grid.selectedItems.length;

    if (itemCount === 0) {
      customAlert(T.t('select_routes_for_event'))
    } else if (eventData["id"] === '') {
      customAlert(T.t('select_event_for_routes'))
    }

    this.grid.remoteRequest({
      url: `/events/${eventData["id"]}/add_routes.json`,
      params: (selectedIds) => { return { route_ids: selectedIds.join(',') } },
      done: () => {
        $.jGrowl(T.t('added_routes_to_item', {count: itemCount, item_name: eventData["text"]}));
        eventSelector.select2('val', '');
        this.$('.bulk_op').hide();
      },
      always: () => {
        this.addingToEvent = false
      }
    })

    return false;
  },

  createExperience: function() {
    const items = this.grid.selectedItems;
    $('#experience_route_ids').val(items.map(x => x.id).join(','))
    $('#create_experience_form').submit()
    return false;
  },

  loadExperiences: function() {
    if (this.experiencesLoading || this.experiencesLoaded) {
      return false;
    }

    this.experiencesLoading = true
    this.expericencsLoaded = false

    // TODO: Loading spinner, if needed
    $.getJSON(`/organizations/${this.clubId}/table_experiences.json?minimal=1`)
      .done((data) => {
        const experienceSelector = this.$('input.experience_add')
        const addButton = this.$(".batch_experience_add")

        addButton.addClass("disabled")
        data.experiences.forEach((obj) => { obj.text = obj.name })
        experienceSelector.val('').select2({
          width: '300px',
          placeholder: T.t('select_experience'),
          data: data.experiences,
          selectOnBlur: true,
          formatNoMatches: () => ''
        });
        experienceSelector.on("change", () => {
          const val = experienceSelector.select2("val")
          if (val === '') {
            addButton.addClass("disabled")
          } else {
            addButton.removeClass("disabled")
          }
        })
        this.experiencesLoaded = true
      })
      .always(() => { this.experiencesLoading = false })
    return false;
  },

  addToExperience: function() {
    if (this.addingToExperience) {
      return
    }

    this.addingToExperience = true
    const experienceSelector = this.$('input.experience_add')
    const experienceData = experienceSelector.select2("data");
    const itemCount = this.grid.selectedItems.length;

    if (itemCount === 0) {
      customAlert(T.t('select_routes_for_experience'))
    } else if (experienceData["id"] === '') {
      customAlert(T.t('select_experience_for_routes'))
    }

    this.grid.remoteRequest({
      url: `/experiences/${experienceData["id"]}/add_routes.json`,
      params: (selectedIds) => { return { route_ids: selectedIds.join(',') } },
      done: () => {
        $.jGrowl(T.t('added_routes_to_item', {count: itemCount, item_name: experienceData["text"]}));
        experienceSelector.select2('val', '');
        this.$('.bulk_op').hide();
      },
      always: () => {
        this.addingToExperience = false
      }
    })
    return false;
  },

  loadCollections: function() {
    if (this.collectionsLoading || this.collectionsLoaded) {
      return false;
    }

    this.collectionsLoading = true
    this.collectionsLoaded = false

    $.getJSON(`/organizations/${this.clubId}/table_collections.json?minimal=1`)
      .done((data) => {
        const collectionSelector = this.$('input.collection_add')
        const addButton = this.$(".batch_collection_add")

        addButton.addClass("disabled")
        data.collections.forEach((obj) => { obj.text = obj.title })
        collectionSelector.val('').select2({
          width: '300px',
          placeholder: T.t('select_collection'),
          data: data.collections,
          selectOnBlur: true,
          formatNoMatches: () => ''
        });
        collectionSelector.on("change", () => {
          const val = collectionSelector.select2("val")
          if (val === '') {
            addButton.addClass("disabled")
          } else {
            addButton.removeClass("disabled")
          }
        })
        this.collectionsLoaded = true
      })
      .always(() => { this.collectionsLoading = false })
    return false;
  },

  addToCollection: function() {
    if (this.addingToCollection) {
      return
    }

    this.addingToCollection = true
    const collectionSelector = this.$('input.collection_add')
    const collectionData = collectionSelector.select2("data");
    const itemCount = this.grid.selectedItems.length;

    if (itemCount === 0) {
      customAlert(T.t('select_routes_for_collection'))
    } else if (collectionData["id"] === '') {
      customAlert(T.t('select_collection_for_routes'))
    }

    this.grid.remoteRequest({
      url: `/collections/${collectionData["id"]}/add_routes.json`,
      params: (selectedIds) => { return { route_ids: selectedIds.join(',') } },
      done: () => {
        $.jGrowl(T.t('added_routes_to_item', {count: itemCount, item_name: collectionData["text"]}));
        collectionSelector.select2('val', '');
        this.$('.bulk_op').hide();
      },
      always: () => {
        this.addingToCollection = false
      }
    })
    return false;
  },

  initTagInputBoxes: function() {
    this.$('.tag_select2_input').val('').select2({
      openOnEnter: false,
      width: '150px',
      placeholder: T.t('route_tags'),
      tokenSeparators: [','],
      tags: this.tags,
      selectOnBlur: true,
      formatNoMatches: function() { return ''; },
      createSearchChoice: (term) => {
        for (var value of this.tags) {
          if (value.toUpperCase() === term.toUpperCase()) {
            return {id: value, text: value};
          }
        }
        return {id: term, text: term}
      }
    });
  },

  batchLock: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op')

    this.grid.remoteRequest({
      url: `/routes/batch_${bulkOp}.json`,
      params: (selectedIds) => { return { route_ids: selectedIds.join(',') } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.routes.forEach(routeData => {
          var route = dataView.getItemById(routeData.id)
          route.locked = routeData.locked
          dataView.updateItem(route.id, route)
        })
        dataView.endUpdate()
      }
    })
  },

  batchUpdateTags: function(e) {
    const tagsStr = this.$('input.tag_names').val();
    const isAdd = $(e.currentTarget).hasClass('batch_add_tags');
    const tagAction = isAdd ? 'add' : 'remove';

    if (tagsStr === '') {
      if(isAdd)
        customAlert(T.t('tag_add_help'));
      else
        customAlert(T.t('tag_remove_help'));
      return;
    }

    this.grid.remoteRequest({
      url: '/routes/batch_update_tags.json',
      params: (selectedIds) => { return { route_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.routes.forEach((routeData) => {
          var route = dataView.getItemById(routeData.id)
          route.tag_names = routeData.tag_names
          dataView.updateItem(route.id, route)

          if (isAdd) {
            route.tag_names.forEach((tag) => {
              if (!this.tags.includes(tag)) {
                this.tags.push(tag)
                this.$('select.filter_by_tag').append('<option value="'+tag+'">'+tag+'</option>')
              }
            })
          }
        })
        dataView.endUpdate();
        this.$('input.tag_names').select2('val', '');
      }
    })
  },

  updateRoute: function(routeId, routeData, doneFunc) {
    const self = this
    this.grid.remoteRequest({
      url: `/routes/${routeId}/club_update.json`,
      params: routeData,
      done: (dataView, data) => {
        // Merge the new data into our existing object
        const route = Object.assign(
          dataView.getItemById(data.id),
          self.cleanRouteData(data)
        )
        dataView.updateItem(route.id, route)
        if (doneFunc) { doneFunc() }
      }
    })
  },

  cleanRouteData: function(data) {
    var route = Object.assign({}, data)
    route.created_at = rwgps.DateExt.parse(route.created_at)
    route.updated_at = rwgps.DateExt.parse(route.updated_at)
    route.location_str = [route.locality, route.administrative_area].filter(Boolean).join(', ');

    return route
  },

  /*
   * misc
   */

  linkMousedOver: function(e) {
    var links = $(e.currentTarget).find('.showPreview')
    if (links.length) {
      var link = links[0]
      if (link.dataset.type === 'route' && link.dataset.id) {
        if (this._routeCard) {
          // if we are moving our cursor from the cell to the link, even though the targets are changing, lets just keep the previous one active
          if ($(e.target).parents().hasClass('tippy-active') || $(e.target).hasClass('tippy-active')) {
            return false
          }

          // destroy a previous tippy
          if( this._routeCard.previousTarget._tippy && !this._routeCard.previousTarget._tippy.state.destroyed) {
            this._routeCard.unmountComponent()
          }
        }
        var renderTarget = document.getElementById('route_hover_preview')
        this._routeCard = rwgps.routeHoverCard(renderTarget, Object.assign({target: e.currentTarget}, link.dataset))
        this._routeCard.previousTarget = e.currentTarget
      }
    }
  },

  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    let size = 0;
    let nameItem;
    _.each(this.grid.slickGrid.getColumns(), function(item) {
      if (item.id == "name")
        nameItem = item;
      else
        size += item.width;
    });
    nameItem.width = this.grid.slickGrid.getViewport().rightPx - size;
    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },
  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  routeInfo: function(e) {
    const routeId = $(e.currentTarget).data('id');
    $.get("/routes/"+routeId+"/club_edit", function(resp) {
      $('#info-modal').html(resp).modal();
    });
  },
  routeLink: function(e) {
    const routeId = $(e.currentTarget).data('id');
    $.get("/routes/"+routeId+"/edit_route_link", function(resp) {
      $('#route-link-modal').html(resp).modal();
    });
  },
  changeGridHeight(amount) {
    const $table = $('#routes_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("routes_grid_height", height, true);
  }

});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/routes_view.js